<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body" class="is-2column" 
    :class="{'is-hidden-header' : targetScrollFlg}"
  >
    <BackgroundImage />
  <DocumentLink />

    <!-- menu:start -->
    <PCMenu
      :class="{'visible':visibleMenu}"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->

    <div id="wrapper">
      <!-- header:start -->
      <header id="header" class="header">
        <PCButtonHistoryBack />
        <PCGuideSearch />
      </header>
      <!-- header:end -->

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button" 
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
      >
        <IconMenu class="icn" 
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- content:start -->
      <div id="content">
        <PCGuideTable />
        <main class="" id="main">
          <div class="box02 white">
            <div class="box02-hdg">
              <h1 class="box02-hdg-title hdg03">{{state.isSearch ? '検索結果' : 'ご利用ガイド'}}</h1>
              <span v-if="!guide.search.load" class="box02-hdg-title-sup">{{guide.pagenation.count}}件</span>
              <span v-if="state.isSearch" @click="action.searchReset" role="button" class="box02-hdg-title-sup-link">検索条件のクリア</span>
            </div>
            <div class="box02-body" id="scroll-target"
              @scroll="handleScroll"
              style="height:calc(100vh - 108px);"
              >
              <p
               v-if="!guide.search.load && (!state.lists || state.lists.length === 0)" 
               class="txt pt32 pb32 pl40 pr40">キーワードに合致する検索結果がありませんでした。<br>検索キーワードを変更して再度検索してください。</p>
              <PCPagenation
                v-if="guide.pagenation.count > guide.search.per_page"
                :count="guide.pagenation.count"
                :per_page="guide.search.per_page"
                :currentPage="guide.pagenation.currentPage"
                @changePage="action.pagenation"
              />
              <FontawesomeIcon v-if="guide.search.load" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
              <ul v-else class="list-result">
                <li v-for="list in state.lists" :key="list.id" class="list-result-item">
                  <div class="list-result-item-main">
                    <div class="list-result-title"><router-link :to="'/pc/guide/' + list.id" v-html="list.title"></router-link></div>
                    <p class="list-result-text" v-html="list.detail"></p>
                    <div v-if="list.category_name" class="list-result-note">
                      <span class="list-result-sup">{{list.category_name}}</span>
                    </div>
                  </div>
                </li>
              </ul>
              <PCPagenation
                v-if="guide.pagenation.count > guide.search.per_page"
                :count="guide.pagenation.count"
                :per_page="guide.search.per_page"
                :currentPage="guide.pagenation.currentPage"
                @changePage="action.pagenation"
                class="mb40"
              />
            </div>
          </div>
        </main>
      </div>
      <!-- content:end -->

      <span id="btnTop" @click="scrollAreaTop('#scroll-target')">TOP</span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import PCMenu from '@/components/pc/popup/PCMenu.vue'
import PCGuideTable from '@/components/pc/partial/guide/PCGuideTable.vue'
import PCGuideSearch from '@/components/pc/partial/guide/PCGuideSearch.vue'
import PCPagenation from '@/components/pc/partial/PCPagenation.vue'

import { GuideList} from '@/logic/guide/GuideList'

export default defineComponent({
  components: {
    PCMenu,
    PCGuideTable,
    PCGuideSearch,
    PCPagenation
  },  
  setup (props, context) {
    return { ...GuideList(props, context) }
  }
})
</script>

<style lang="scss" scoped>
#content {
  display: flex;
  flex-wrap: nowrap;
  background-color: #fff;
  border-radius: 8px 8px 0 0;
}
.box02-body {
  overflow: auto;
  .date {
    color: #ccc;
    padding: 48px 40px 0;
  }
}
.box02-body-detail {
  padding: 40px;
  .hdg02 {
    margin: 80px 0 32px;
    font-size: 2.4rem;
  }
  .hdg03 {
    margin: 32px 0 24px;
    font-size: 1.8rem;
  }
  .hdg04 {
    margin: 24px 0 24px;
    font-size: 1.6rem;
  }
  .txt {
    margin: 24px 0 24px;
    font-size: 1.4rem;
    &-sup {
      margin: 24px 0 24px;
      font-size: 1.2rem;
      color: #999999 !important;
    }
  }
  .tbl04 {
    margin: 32px 0 32px;
    table {
      table-layout: fixed;
    }
    .tbl04-bodyarea {
      padding: 0px;
      border: none;
    }
    .tbl04-table th,.tbl04-table td {
      border: 1px solid #DDDDDD;
    }
    .txt-sup {
      margin-top: 20px ;
    }
  }

  .list02 {
    margin: 32px 0;
    .list02-item .wrap .label .main {
      color: #555555;
      font-size: 1.4rem;
    }
  }
  .list03-num {
    margin: 32px 0;
    ol {
      counter-reset: number;
      list-style: none;
    }
    ol li {
      position: relative;
    }
    ol li:before {
      counter-increment: number;
      content: counter(number);
      position: absolute;
      top: 6px;
      left: 4px;
      color: #555555;
      font-size: 1.4rem;
    }

    ol .list03-label {
      padding-left: 24px;
      color: #555555;
      font-size: 1.4rem;
    }
  }
  .img-wide, .img-small {
    margin: 32px 0;
    img {
      display: block;
      margin: 0 auto;
    }
    .txt-sup {
      margin-top: 20px;
    }
  }
  .img-wide img {
    width: 100%;
  }
  .img-small img {
    width: 50%;
    margin-left: 0;
  }
}
</style>
